import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/projetos?datainicialetapa=${filtro.dataInicial}&datafinaletapa=${filtro.dataFinal}
                &tipocontratacao=${filtro.tipoContratacao}&natureza=${filtro.natureza}&modulo=${filtro.modulo}&codsolucao=${filtro.codSolucao}
            `)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/projetos/${projetoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/etapas/${etapaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimento(etapaId) {
        return axiosJwt
            .patch(`${api}/sgtec/uabs/etapas/${etapaId}/excluircomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEtapaRateio(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/etapas/${etapaId}/rateio`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/sgtec/uabs/dotacoes/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetos(codUnidade) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/dotacoes/unidades/${codUnidade}/projetos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(codUnidade, codProjeto) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/dotacoes/unidades/${codUnidade}/projetos/${codProjeto}/acoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    salvarEtapaRateio(etapaRateio) {
        return axiosJwt
            .post(
                `${api}/sgtec/uabs/etapas/${etapaRateio.etapaId}/rateio`,
                etapaRateio
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/etapas/${etapaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterSolucoes(modulo) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/projetos/solucoes/${modulo}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/etapas/${etapaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }

}
